import { svc_addOne, svc_editOne, svc_deleteOne, svc_search } from "@/services";
import { showServerResponse } from "@/utils/message";
const apiPrefix = "option_groups/menu_items";

const Model = {
	namespace: "m_MenuItemOptionGroup",
	state: {},
	reducers: {},
	effects: {
		*addOptionGroup({ payload }, { call, put }) {
			delete payload.id;
			const response = yield call(svc_addOne, apiPrefix, payload);
			showServerResponse(response);
			return response;
		},
		*updateOptionGroup({ payload }, { call, put }) {
			if (payload && payload.id) {
				const response = yield call(svc_editOne, apiPrefix, payload, "id");
				showServerResponse(response);
				return response;
			}
		},
		*deleteOptionGroup({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(svc_deleteOne, "option_groups/delete", payload, "id");
			showServerResponse(response);
			return response;
		},
		*cloneOptionGroup({ payload }, { call, put }) {
			const response = yield call(svc_addOne, apiPrefix, payload, `clone/${payload.id}`);
			showServerResponse(response);
			return response;
		},
		*reorderOptionGroup({ payload }, { call, put }) {
			if (payload && payload.length > 0) {
				const response = yield call(svc_addOne, apiPrefix, payload, "reorder");
				showServerResponse(response);
				return response;
			}
		},
		*updateNextOptionGroup({ payload }, { call, put }) {
			if (payload && payload.id) {
				const response = yield call(svc_editOne, "option_groups/child/menu_items", payload, "id");
				showServerResponse(response);
				return response;
			}
		},
		// shared with Category Option Group
		*getChildOptionGroup({ payload }, { call, put }) {
			const searchParams = {
				...payload.menu_item_id && { menu_item_id: payload.menu_item_id },
				...payload.category_id && { category_id: payload.category_id },
				...payload.menu_item_option_group_id && { menu_item_option_group_id: payload.menu_item_option_group_id },
				...payload.category_option_group_id && { category_option_group_id: payload.category_option_group_id }
			};

			const response = yield call(svc_search, "option_groups/child", searchParams);
			showServerResponse(response);
			return response;
		},
	},
	subscriptions: {},
};

export default Model;
